import React, { FC } from 'react';

interface LegalNoticeLinkProps {
  url: string | null;
}

// Cible du composant <0> de `cookies-consent-modalCheckLegalNoticeText` : <Trans> injecte le libellé.
// `url` vaut `null` quand l'attribut `data-url` manque : React omet alors l'attribut `href`.
const LegalNoticeLink: FC<LegalNoticeLinkProps> = ({ url, children }) => (
  <a href={url ?? undefined} target="_blank" rel="noopener noreferrer">
    {children}
  </a>
);

export default LegalNoticeLink;
